export default function initialState() {
  return {
    validated: false,
    clients: null,
    members: null,
    listings: ['coming-soon', 'active', 'cancelled', 'expired'],
    transactions: ['pending', 'closed', 'failed'],
    errorList: null,
    howToVideo: null,
    howToTitle: null,
    person: null,
    deal: null,
    form: {
      id: null,
      user_slug: null,
      status: null,
      transaction_type: null,
      units: true,
      listing_date: null,
      target_mls_date: null,
      active_date: null,
      expiration_date: null,
      contract_date: null,
      close_date: null,
      sale_type: null,
      contingent_sale: false,
      transaction_fee: 0,
      listing_price: 0,
      sale_price: 0,
      amount: 0,
      commission_type: 0,
      referral_fee: false,
      referral_type: 0,
      referral_amount: 0,
      broker_paid: false,
      broker_type: 0,
      broker_amount: 0,
      franchise_fee_paid: false,
      franchise_fee_type: 0,
      franchise_fee_amount: 0,
      broker_commission: false,
      broker_commission_type: 0,
      broker_commission_amount: 0,
      other_cos: 0,
      primary_source: null,
      loan_officer: null,
      escrow_officer: null,
      client_id: null,
      property_id: null,
      primary_agent: null,
      agent_id: null,
      members: [
        {
          id: "",
          name: "",
          amount: 0,
          commission_type: 0,
          cap: false,
          cap_type: 0,
          cap_amount: 0,
          royalty: false,
          royalty_type: 0,
          royalty_amount: 0
        }
      ],
      client_type: 0,
      client: {
        slug: null,
        name: "",
        phone: "",
        email: ""
      },
      property: {
        id: null,
        address: "",
        city: "",
        state: "",
        zipcode: ""
      },
      companies: [],
    },
    statuses: {
      listings: [
        {
          key: 'coming-soon-status',
          label: 'Coming Soon',
          value: 'coming-soon'
        },
        {
          key: 'active-status',
          label: 'Active',
          value: 'active'
        },
        {
          key: 'cancelled-status',
          label: 'Cancelled',
          value: 'cancelled'
        },
        {
          key: 'expired-status',
          label: 'Expired',
          value: 'expired'
        }
      ],
      transactions: [
        {
          key: 'pending-status',
          label: 'Pending',
          value: 'pending'
        },
        {
          key: 'closed-status',
          label: 'Closed',
          value: 'closed'
        },
        {
          key: 'failed-status',
          label: 'Failed',
          value: 'failed'
        }
      ]
    },
    officers: false,
  }
}